import React from 'react';
import {useAuth0, User} from '@auth0/auth0-react';
import {Box, Button, Center, Flex, Link} from '@chakra-ui/react';
import {WithId} from '../../shared/util';
import {ObjectId} from 'bson';

export const CustomerListWithLogin = ({
  customers,
}: {
  customers: WithId<{name: string}>[];
}) => {
  const {loginWithRedirect} = useAuth0();

  const handleLogin = async (customerId: ObjectId) => {
    // Fetch a new token for the selected customer and redirect to the accounts page.
    await loginWithRedirect({authorizationParams: {customerId}});
  };

  return (
    <Flex direction="column" gap={2}>
      {customers.map((customer) => {
        return (
          <Button
            alignContent="start"
            key={customer._id.toString()}
            onClick={() => handleLogin(customer._id)}
            variant="outline"
          >
            {customer.name}
          </Button>
        );
      })}
    </Flex>
  );
};

export const CustomerSelector = ({
  customers,
  logout,
  user,
}: {
  customers: WithId<{name: string}>[];
  logout: Function;
  user: User;
}) => {
  return (
    <Center bgColor="kgray.400" minH="100vh" py={10}>
      <Flex
        bgColor="kgray.100"
        px={20}
        py={10}
        borderRadius={25}
        direction="column"
        gap={4}
      >
        <Box as="img" h="50px" src="/Keyplay_Primary_Logo.svg" />
        <Box>Welcome {user.email}</Box>
        <CustomerListWithLogin customers={customers} />
        <Link
          alignSelf="end"
          color="kblue.400"
          onClick={() => logout()}
          variant="outline"
        >
          Logout
        </Link>
      </Flex>
    </Center>
  );
};
